import { createContext } from 'react';

const JpApiClientContext = createContext({});

export default JpApiClientContext;
